import React, { PureComponent } from 'react';
import TableRow from '../../../../src/components/common/table-row';
import { createContainer } from '@dbk-legacy/muster/react';
import { List, ListItem } from '@dbk/ui-list'
import { UPLOADHISTORY_FILTER_NAME } from '../../../../src/constants';

class UploadHistoryListHeader extends PureComponent {
  constructor(props) {
    super(props);
  }
  render() {
    const {
      i18n: { messages } } = this.props;
    return (
      <div className="columns large-12 medium-12 small-12 header-padding">
        <TableRow>
          <TableRow.Column align="left" >
            <TableRow>
              <TableRow.Column align="left">
                <span className="headers-font" onClick={() => this.props.onSortClick(UPLOADHISTORY_FILTER_NAME.BPID)}>
                  <span>{messages['app.documentUploadHistory.bpHeader']}</span>
                  {this.props.renderSortArrow(UPLOADHISTORY_FILTER_NAME.BPID)}
                </span>
              </TableRow.Column>

              <TableRow.Column align="left">
                <span className="headers-font" onClick={() => this.props.onSortClick(UPLOADHISTORY_FILTER_NAME.EBANKING_CONTRACT)}>
                  <span>{messages['app.documentUploadHistory.e-bankingContractheader']}</span>
                  {this.props.renderSortArrow(UPLOADHISTORY_FILTER_NAME.EBANKING_CONTRACT)}
                </span>
              </TableRow.Column>

              <TableRow.Column align="left">
                <span className="headers-font" onClick={() => this.props.onSortClick(UPLOADHISTORY_FILTER_NAME.CONTRACT_NAME)}>
                  <span>{messages['app.documentUploadHistory.contractName']}</span>
                  {this.props.renderSortArrow(UPLOADHISTORY_FILTER_NAME.CONTRACT_NAME)}
                </span>
              </TableRow.Column>

              <TableRow.Column align="left">
                <span className="headers-font" onClick={() => this.props.onSortClick(UPLOADHISTORY_FILTER_NAME.DOCUMENT_NAME)}>
                  <span>{messages['app.documentUploadHistory.documentName']}</span>
                  {this.props.renderSortArrow(UPLOADHISTORY_FILTER_NAME.DOCUMENT_NAME)}
                </span>
              </TableRow.Column>

              <TableRow.Column align="left">
                <span className="headers-font" onClick={() => this.props.onSortClick(UPLOADHISTORY_FILTER_NAME.UPLOAD_DATE)}>
                  <span>{messages['app.documentUploadHistory.uploadDate']}</span>
                  {this.props.renderSortArrow(UPLOADHISTORY_FILTER_NAME.UPLOAD_DATE)}
                </span>
              </TableRow.Column>

              <TableRow.Column align="left">
                <span className="headers-font" onClick={() => this.props.onSortClick("status")}>
                  <span>{messages['app.documentUploadHistory.status']}</span>
                  {this.props.renderSortArrow(UPLOADHISTORY_FILTER_NAME.STATUS)}
                </span>
              </TableRow.Column>
            </TableRow>
          </TableRow.Column>
        </TableRow>
      </div>
    );
  }
}

export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    },
  }
})(UploadHistoryListHeader);
